import { render, staticRenderFns } from "./userNew.vue?vue&type=template&id=54e7dd1d&"
import script from "./userNew.vue?vue&type=script&lang=js&"
export * from "./userNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports